<template>
    <div class="billing-main-scroll">
        <div class="billing-cards-header">
            <div class="billing-section-title" style="margin-bottom: 0;">{{ $t('common.billing.savedCards') }}</div>
            <button class="billing-add-card-btn" @click="bs.toggleAddCard()">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                {{ $t('common.billing.addCard') }}
            </button>
        </div>

        <div class="billing-cards-list">
            <div v-for="card in bs.CARDS" :key="card.id" class="billing-card-item">
                <span :class="['billing-card-brand', 'billing-card-brand--' + card.brand]">{{ brandLabel(card.brand) }}</span>
                <div class="billing-card-info">
                    <div class="billing-card-number">&bull;&bull;&bull;&bull; {{ card.number }}</div>
                    <div class="billing-card-holder">{{ card.holder }}</div>
                </div>
                <span class="billing-card-expiry">{{ card.expiry }}</span>
                <span v-if="card.isDefault" class="billing-card-default">{{ $t('common.billing.default') }}</span>
                <button v-else class="billing-card-set-default-btn" @click="bs.setDefaultCard(card.id)">{{ $t('common.billing.setDefault') }}</button>
                <div class="billing-card-actions">
                    <button class="billing-card-action-btn">
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"/></svg>
                    </button>
                    <button class="billing-card-action-btn billing-card-action-btn--danger">
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
                    </button>
                </div>
            </div>
        </div>

        <div v-if="bs.state.addCardOpen" class="billing-card-form">
            <div class="billing-form-title">{{ $t('common.billing.addNewCard') }}</div>
            <div class="billing-form-row">
                <div class="billing-form-group">
                    <label class="billing-form-label">{{ $t('common.billing.cardNumber') }}</label>
                    <input class="billing-form-input" type="text" placeholder="0000 0000 0000 0000" maxlength="19">
                </div>
            </div>
            <div class="billing-form-row">
                <div class="billing-form-group" style="max-width: 120px;">
                    <label class="billing-form-label">{{ $t('common.billing.cardExpiry') }}</label>
                    <input class="billing-form-input" type="text" placeholder="AA/YY" maxlength="5">
                </div>
                <div class="billing-form-group" style="max-width: 100px;">
                    <label class="billing-form-label">CVV</label>
                    <input class="billing-form-input" type="text" placeholder="000" maxlength="3">
                </div>
            </div>
            <div class="billing-form-row">
                <div class="billing-form-group">
                    <label class="billing-form-label">{{ $t('common.billing.cardHolder') }}</label>
                    <input class="billing-form-input" type="text" :placeholder="$t('common.billing.cardHolderPlaceholder')">
                </div>
            </div>
            <div class="billing-form-actions">
                <button class="billing-btn billing-btn--ghost" @click="bs.toggleAddCard()">{{ $t('common.billing.cancelAction') }}</button>
                <button class="billing-btn billing-btn--primary">{{ $t('common.billing.saveCard') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import billingService from './billingService'

export default {
    name: 'BillingCards',
    computed: {
        bs() {
            return billingService
        },
    },
    methods: {
        brandLabel(brand) {
            if (brand === 'visa') return 'VISA'
            if (brand === 'mastercard') return 'MC'
            return brand.toUpperCase()
        },
    },
}
</script>
